import React from 'react';
import { Menu, Dropdown, Button, Icon } from 'antd';
import { Link } from 'react-router-dom';

const { SubMenu, Item: MenuItem, Divider: MenuDivider } = Menu;

function MenuMobilePressure({ storageEnable, seepageEnable, seepageV2Enable, rainEnable }) {
  if (!storageEnable && !seepageEnable && !rainEnable && !seepageV2Enable) {
    return (
      <MenuItem>
        <Link to="/pressure/history">กราฟระดับน้ำและแรงดันในแต่ละจุด</Link>
      </MenuItem>
    );
  }

  return (
    <SubMenu title="การประมวลข้อมูล">
      {storageEnable && (
        <MenuItem>
          <Link to="/water/storage">ปริมาณการกักเก็บน้ำในอ่าง</Link>
        </MenuItem>
      )}

      {seepageEnable && (
        <MenuItem>
          <Link to="/pressure/seepage">อัตราการรั่วซึม</Link>
        </MenuItem>
      )}

      {seepageV2Enable && (
        <MenuItem>
          <Link to="/pressure/seepage-v2">กราฟอัตราการรั่วซึม</Link>
        </MenuItem>
      )}

      <MenuItem>
        <Link to="/pressure/history">กราฟระดับน้ำและแรงดันในแต่ละจุด</Link>
      </MenuItem>

      {rainEnable && (
        <MenuItem>
          <Link to="/rain/history">ปริมาณน้ำฝน</Link>
        </MenuItem>
      )}
    </SubMenu>
  );
}

function getMenu(props) {
  const {
    damList,
    seismic: { enable: seismicEnable, station },
    pressure: {
      enable: pressureEnable,
      waterStorage: { enable: storageEnable },
    },
    seepage: { enable: seepageEnable },
    seepage_v2: { enable: seepageV2Enable },
    rain: { enable: rainEnable },
  } = props;

  return (
    <Menu>
      <SubMenu title="รายชื่ออ่าง">
        {damList.map(({ title, link }) => (
          <MenuItem key={title}>
            <a href={link} target="_blank">
              {title}
            </a>
          </MenuItem>
        ))}
      </SubMenu>

      {pressureEnable && (
        <MenuItem>
          <Link to="/">ระบบจำลองเหตุการณ์</Link>
        </MenuItem>
      )}

      {pressureEnable &&
        MenuMobilePressure({ storageEnable, seepageEnable, seepageV2Enable, rainEnable })}

      {seismicEnable && (
        <SubMenu title="กราฟแสดงค่าการสั่นสะเทือน">
          <MenuItem>
            <Link to="/seismic/event">ประมวลเหตุการณ์แรงสั่นสะเทือนที่ผ่านมา</Link>
          </MenuItem>
          <MenuDivider />
          {Object.keys(station).map((stationId) => (
            <MenuItem key={stationId}>
              <Link to={`/seismic/station/${stationId}`}>{station[stationId]}</Link>
            </MenuItem>
          ))}
        </SubMenu>
      )}
    </Menu>
  );
}

function MenuMobile(props) {
  return (
    <div className="visible-xs-block">
      <Dropdown overlay={getMenu(props)}>
        <Button>
          <Icon type="menu" />
        </Button>
      </Dropdown>
    </div>
  );
}

export default MenuMobile;



// WEBPACK FOOTER //
// ./resources/assets/js/components/MenuMobile/index.js